import Customers, { ICustomer } from './Customers';

export type { ICustomer };
export default Customers;
